import React from 'react';
import { InsightsOverview } from '../components/InsightsOverview';
import { RevenueInsights } from '../components/RevenueInsights';

export const Insights: React.FC = () => {
  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <header style={{ marginBottom: '24px' }}>
        <h1 style={{ fontSize: '2rem', color: '#333', margin: '0 0 8px 0' }}>Insights</h1>
        <p style={{ color: '#666', margin: 0 }}>Track and analyze your business insights</p>
      </header>

      <InsightsOverview />

      <RevenueInsights />

      <div
        style={{
          textAlign: 'center',
          padding: '60px 20px',
          backgroundColor: '#f5f5f5',
          borderRadius: '8px',
          color: '#999',
          marginTop: '40px'
        }}
      >
        <p style={{ fontSize: '1.2rem', margin: 0 }}>Additional insights coming soon</p>
      </div>
    </div>
  );
};
